const errorsTranslated = require('@transfeeradev/api-enums/bankImportFiles/errorsTranslated');
const UtilsService = require('./UtilsService');
const { logger } = require('@transfeeradev/logger');
const { errors } = require('@transfeeradev/api-enums');

const CNAB_REGEX = /[A-Za-z0-9]{2}:/g;
const IS_CNAB_ERROR_REGEX = /^[A-Za-z0-9]{2}:/;

class TransferFailedReasonService {
  constructor(userAgent) {
    this._userAgent = userAgent;
  }

  translate(error) {
    if (/contacerta/.test(this._userAgent)) {
      return error;
    } else if (/cnab240-api-/.test(this._userAgent)) {
      return this._cnab240(error);
    } else if (/automation-\d+/.test(this._userAgent)) {
      return this._automation(error);
    }

    return this._handleGeneric(error);
  }

  _handleGeneric(error) {
    if (IS_CNAB_ERROR_REGEX.test(error)) {
      return this._cnab240(error);
    } else {
      return this._automation(error);
    }
  }

  _cnab240(error) {
    const codes = error.match(CNAB_REGEX).map(code => code.replace(':', ''));

    return codes.reduce((acc, code) => {
      if (!errorsTranslated[code]) {
        logger.error("CNAB240 error with code %s don't have translation, please implement.", code);

        const regex = new RegExp(`(${code}).+?(?=[A-Za-z0-9]{2}:)|(${code}).+`);

        return (acc += (acc ? '. ' : '') + error.match(regex)[0]);
      } else {
        if (!acc.includes(errorsTranslated[code])) {
          return (acc += (acc ? '. ' : '') + errorsTranslated[code]);
        }

        return acc;
      }
    }, '');
  }

  _automation(error) {
    const errorCheck = UtilsService.removeAccents(error).toLowerCase().trim();

    if (
      errorCheck.includes('dac da conta do recebedor invalido') ||
      errorCheck === 'conta corrente nao encontrada' ||
      errorCheck === 'conta de destino invalida.' ||
      errorCheck.includes('conta corrente invalida') ||
      errorCheck.includes('conta invalida') ||
      errorCheck === 'agencia invalida' ||
      errorCheck.includes('conta informada para credito invalida')
    ) {
      return errors.ptBr.transferFailedReason.INVALID_AGENCY_OR_ACCOUNT_OR_ACCOUNT_VD.message;
    }

    if (
      errorCheck.includes('agencia ou conta destinataria do credito invalida') ||
      errorCheck.includes('agencia ou conta do destino estao incorretas') ||
      errorCheck.includes('os dados informados estao incorretos') ||
      errorCheck.includes('por solicitacao de cliente da instituicao participante recebedora')
    ) {
      return errors.ptBr.transferFailedReason.INCORRECT_RECIPIENT_DATA.message;
    }

    if (errorCheck.includes('transferencia devolvida')) {
      return errors.ptBr.transferFailedReason.REFUNDED_CREDIT_AMOUNT.message;
    }

    if (
      errorCheck.includes('agencia') &&
      (errorCheck.includes('conta corrente') || errorCheck.includes('conta destino')) &&
      errorCheck.includes('digito verificador invalido')
    ) {
      return errors.ptBr.transferFailedReason.INVALID_AGENCY_VD_OR_ACCOUNT_VD.message;
    }

    if (
      errorCheck.includes('agencia itau inexistente') ||
      errorCheck.includes('agencia/conta inexistente') ||
      errorCheck.includes('agencia inexistente')
    ) {
      return errors.ptBr.transferFailedReason.AGENCY_NOT_FOUND.message;
    }

    if (errorCheck.includes('agencia desativada') || errorCheck.includes('agencia destino nao cadastrada')) {
      return errors.ptBr.transferFailedReason.AGENCY_NOT_FOUND_OR_DISABLED.message;
    }

    if (
      errorCheck.includes('por favor, preencha corretamente o numero da agencia') ||
      (errorCheck.toLowerCase().includes('agencia') &&
        (errorCheck.includes('digito verificador invalido') || errorCheck.includes('agencia invalida')))
    ) {
      return errors.ptBr.transferFailedReason.INVALID_AGENCY_OR_VD.message;
    }

    if (errorCheck.includes('conta encerrada')) {
      return errors.ptBr.transferFailedReason.ACCOUNT_CLOSED.message;
    }

    if (errorCheck.includes('cta.corrent.da poup.encerrada')) {
      return errors.ptBr.transferFailedReason.CHECKING_ACCOUNT_CLOSED.message;
    }

    if (errorCheck.includes('limite excedido para esta conta')) {
      return errors.ptBr.transferFailedReason.RECEPIENT_ACCOUNT_EXCEEDED_CREDIT_LIMIT.message;
    }

    if (
      errorCheck.includes('nao disponivel para esta conta') ||
      errorCheck.includes('temporariamente nao disponivel')
    ) {
      return errors.ptBr.transferFailedReason.RECEPIENT_ACCOUNT_CREDIT_NOT_ALLOWED.message;
    }

    if (errorCheck.includes('conta invalid') && errorCheck.includes('agencia')) {
      return errors.ptBr.transferFailedReason.INVALID_AGENCY_OR_ACCOUNT.message;
    }

    if (
      errorCheck.includes('numero da conta invalido') ||
      errorCheck.includes('o digito verificador informado e invalido.') ||
      errorCheck.includes('conta corrente: digito verificador invalido.') ||
      errorCheck.includes('conta destino: digito verificador invalido.') ||
      (errorCheck.includes('conta corrente') &&
        !errorCheck.includes('agencia') &&
        errorCheck.includes('digito verificador invalido'))
    ) {
      return errors.ptBr.transferFailedReason.INVALID_ACCOUNT_OR_VD.message;
    }

    if (
      errorCheck.includes('conta em liquidacao judicial') ||
      errorCheck.includes('conta bloqueada') ||
      errorCheck.includes('conta corrente de credito inativa/bloqueada') ||
      errorCheck === 'Conta com bloqueio'
    ) {
      return errors.ptBr.transferFailedReason.ACCOUNT_BLOCKED.message;
    }

    if (
      errorCheck.toLowerCase().includes('conta inexistente') ||
      errorCheck.includes('nao encontramos a conta') ||
      errorCheck.includes('conta de poupanca inexistente') ||
      errorCheck.includes('conta corrente inter invalida')
    ) {
      return errors.ptBr.transferFailedReason.ACCOUNT_NOT_FOUND.message;
    }

    if (errorCheck.includes('variacao invalida')) {
      return errors.ptBr.transferFailedReason.INVALID_ACCOUNT_VARIATION.message;
    }

    if (errorCheck.includes('conta encerrada')) {
      return errors.ptBr.transferFailedReason.ACCOUNT_CLOSED.message;
    }

    if (errorCheck.includes('agencia creditada desativada')) {
      return errors.ptBr.transferFailedReason.AGENCY_DISABLED.message;
    }

    if (
      errorCheck === 'ted devolvida' ||
      errorCheck === 'ted devolvido' ||
      errorCheck.includes('retorno de credito nao pago') ||
      errorCheck === 'estorno de credito nao pago.' ||
      errorCheck.includes('doc / ted devolvido pelo banco recebedor')
    ) {
      return errors.ptBr.transferFailedReason.TED_REFUNDED.message;
    }

    if (
      errorCheck === 'ted devolvida dif titularidade str divergencia no cpf/cnpj' ||
      errorCheck.includes('cpf/cnpj do destino esta incorreto')
    ) {
      return errors.ptBr.transferFailedReason.TED_REFUNDED_DOCUMENT_IS_DIVERGENT.message;
    }

    if (
      errorCheck.includes('transacao nao permitida para a conta de destino. contacte o recebedor') ||
      errorCheck.includes('conta de destino nao permite creditos') ||
      errorCheck.includes('conta destino nao permite credito')
    ) {
      return errors.ptBr.transferFailedReason.TRANSACTION_NOT_ALLOWED_AND_AMOUNT_REFUNDED_BY_BANK.message;
    }

    if (
      errorCheck.includes('lancamento excede o valor do saldo') ||
      errorCheck === 'x5 - capturar texto no bit 120' ||
      errorCheck === 'ca - conta con saldo maior que o permitido.'
    ) {
      return errors.ptBr.transferFailedReason.ACCOUNT_WITH_MONTHLY_LIMIT.message;
    }

    if (errorCheck === 'rejeitado pelo banco') {
      return errors.ptBr.transferFailedReason.REJECTED_BY_RECEPIENT_BANK.message;
    }

    if (
      (errorCheck.includes('cpf/cnpj') && errorCheck.includes('diverge com o retornado pelo banco:')) ||
      errorCheck === 'tipo/numero de inscricao invalido' ||
      errorCheck.includes('ausencia ou divergencia na indicacao do cpf/cnpj') ||
      errorCheck.includes('divergencia na titularidade')
    ) {
      return errors.ptBr.transferFailedReason.INFORMED_DOCUMENT_IS_DIVERGENT_FROM_ACCOUNT_OWNER.message;
    }

    if (errorCheck.includes('utilize a opcao de transferencia para conta poupanca')) {
      return errors.ptBr.transferFailedReason.CHECKING_ACCOUNT_NOT_ALLOWED.message;
    }

    if (errorCheck.includes('mensagem invalida para o tipo de transacao ou finalidade')) {
      return errors.ptBr.transferFailedReason.INVALID_ACCOUNT_TYPE_OR_EXTERNAL_PAYMENT_NOT_ALLOWED.message;
    }

    if (errorCheck.includes('n/a')) {
      return errors.ptBr.transferFailedReason.DATA_NOT_FOUND_ON_BANK.message;
    }

    if (errorCheck.includes('conta destino nao existe mais')) {
      return errors.ptBr.transferFailedReason.ACCOUNT_NOT_FOUND_OR_CLOSED.message;
    }

    if (
      errorCheck.includes('conta destino nao esta apta a receber o valor enviado') ||
      errorCheck.includes('nao conformidade no pagamento')
    ) {
      return errors.ptBr.transferFailedReason.TRANSACTION_NOT_ALLOWED_AND_REFUNDED_BY_BANK.message;
    }

    if (errorCheck.includes('cpf/cnpj inapto junto a receita federal do brasil')) {
      return errors.ptBr.transferFailedReason.RECEPIENT_BLOCKED_PAYMENT_NOT_ALLOWED.message;
    }

    return error;
  }
}

module.exports = TransferFailedReasonService;
